export const createOccupancy = (rows: number, cols: number) => {
  const cells = new Array(rows * cols).fill(false)
  const index = (row: number, col: number) => row * cols + col

  const isValidPosition = (
    row: number,
    col: number,
    width: number,
    height: number
  ) => {
    return (
      row >= 0 &&
      col >= 0 &&
      height > 0 &&
      width > 0 &&
      row + height <= rows &&
      col + width <= cols
    )
  }

  const isFree = (row: number, col: number, width: number, height: number) => {
    if (!isValidPosition(row, col, width, height)) {
      return false
    }

    for (let r = row; r < row + height; r += 1) {
      for (let c = col; c < col + width; c += 1) {
        if (cells[index(r, c)]) return false
      }
    }
    return true
  }

  const occupy = (row: number, col: number, width: number, height: number) => {
    if (!isValidPosition(row, col, width, height)) {
      return
    }

    for (let r = row; r < row + height; r += 1) {
      for (let c = col; c < col + width; c += 1) {
        cells[index(r, c)] = true
      }
    }
  }

  return { isFree, occupy }
}
